import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faFlipboard,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'
import {
  faChevronDown
}
from '@fortawesome/free-solid-svg-icons'
import VueLazyload from 'vue-lazyload'
import ScrollView from 'vue-scrollview'
import VueCarousel from 'vue-carousel'
import VueAnalytics from 'vue-analytics'

Vue.use(VueCarousel)

library.add(faFacebookF, faTwitter, faInstagram, faFlipboard, faYoutube, faChevronDown)

Vue.component('font-awesome-icon', FontAwesomeIcon)

const options = {
  throttle: 100,
  callbacks: []
}

Vue.use(ScrollView, options)
Vue.use(VueLazyload)

Vue.use(VueAnalytics, {
  id: 'UA-80728886-38',
  router
})

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
